// import GraphiQL from 'graphiql';
import { createGraphiQLFetcher } from '@graphiql/toolkit';
import 'graphiql/graphiql.min.css';
import './GraphqlEditor.css';
import { useApiId } from '../../api/ViewApiHooks';
import envs from '../../../config/envs';
import { useAuthHeaders } from '../../auth/AuthState';
import { useRunQueryApiV3 } from './GraphqlHooksV3';
import { useMemo, } from 'react';
import './graphiql.scss';
import { GraphiQL } from '../GraphqlV4';



function GraphQLEditor({
  accessToken
}: {
  accessToken?: string;
}): JSX.Element {
  const apiId = useApiId();
  const [{ result, graphqlState, setGraphqlState }] = useRunQueryApiV3();

  const response = JSON.stringify(result.result, null, 2);

  const headers = useAuthHeaders();

  const fetcher = useMemo(() => {
    return createGraphiQLFetcher({
      url: `${envs.ZettaBackendApiPrivate}/userapis/${apiId}/graphql`,
      // @ts-ignore
      headers: accessToken ? {
        Authorization: `Bearer ${accessToken}`
      } : headers,
    });
  }, [apiId, accessToken]);

  return (
    <div className='gql-editor h-[60vh] min-h-[60vh]'>
      <GraphiQL
        apiId={apiId || ''}
        // TODO: Dark theme - https://github.com/graphql/graphiql/issues/129
        fetcher={fetcher}
        defaultQuery={graphqlState.query}
        variables={undefined}
        response={response}
        visiblePlugin="Documentation Explorer"
        onEditVariables={(variables) => {
          setGraphqlState({
            ...graphqlState,
            variables,
          });
        }}
        onEditQuery={(newQuery) => {
          setGraphqlState({
            ...graphqlState,
            query: newQuery || '',
          });
        }}
      ></GraphiQL>
    </div>
  );
}

export default GraphQLEditor;
